export default __webpack_public_path__ + "static/media/woman-developer.c23df006.jpg";